import {Component, Input, OnInit} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import { customColumnsPersonnel, randomData} from "../sites-adresses/data/datable.data";
import {AddContactComponent} from "./add-contact/add-contact.component";
import {Establishment} from "../../../../../models/Establishment";
import {PersonsService} from "../../../../../services/persons.service";
import {FormBuilder} from "@angular/forms";
import {AuthService} from "../../../../../services/auth.service";
import {debounceTime} from "rxjs";

@Component({
  selector: 'app-personnel',
  templateUrl: './personnel.component.html',
  styleUrl: './personnel.component.scss'
})
export class PersonnelComponent implements OnInit {

  @Input() establishment: Establishment;
  protected readonly customColumnsPersonnel = customColumnsPersonnel;

  offset = 0;
  limit = 10;
  loading = false;
  form = this.fb.group({
    etablissementId: this.auth.id,
    keyword: [''],
    offset: this.offset,
    limit: this.limit,
  })
  personsList: any[] = []
  totalItems: number
 constructor(private dialog: MatDialog,
             private personService: PersonsService,
             private fb: FormBuilder,
             private auth: AuthService,
             ) {
 }

 ngOnInit() {
   // this.getPersonnelFilter()
   this.form.get('keyword')?.valueChanges.pipe(debounceTime(700)).subscribe(value => {
     this.getPersonnelFilter()
   })
   this.personService.getRefreshData().subscribe({
     next: value => {
       this.getPersonnelFilter()
     }
   })
 }

 getPersonnelFilter() {
   this.loading = true;

   this.personService.getPersonsFilter(this.form.value, "/v2").subscribe({
     next: ({content, totalElements}) => {
       this.personsList = content.map((person: any) => {
         const item = {
           ...person,
           name: `${person.firstName} ${person.lastName}`,
         }
         return item
       });
       this.totalItems = totalElements
       this.loading = false;

     }
   })
 }

  openAddSiteDialog() {
    const dialogRef =this.dialog.open(AddContactComponent, {
      width: '700px',
      autoFocus: false,

    })
    dialogRef.afterClosed().subscribe(value => {
      if (value) {
        this.getPersonnelFilter()
      }
    })
  }

  pagination(event: any) {
    this.form.get('offset')?.patchValue(event.pageIndex)
    this.getPersonnelFilter();
  }

}
